import { Inject, Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs/index";
import { map } from "rxjs/operators";
import {
  GETS_FEATURE_FLAGS,
  GetsFeatureBaseService,
} from "./gets-feature-base.service";

@Injectable({
  providedIn: "root",
})
export class FeatureFlagsService {
  private featureFlags: ReplaySubject<Set<string>> = new ReplaySubject(1);

  constructor(
    @Inject(GETS_FEATURE_FLAGS) private getsFeatureFlags: GetsFeatureBaseService
  ) {
    this._init();
  }

  private _init(): void {
    console.log("::@@ INITIALIZING FEATURE FLAGS");
    this.getsFeatureFlags.getAll().subscribe((featureFlags: Set<string>) => {
      this.featureFlags.next(featureFlags);
      console.log("::@@ FEATURE FLAGS CHANGED");
    });
  }

  public hasFlags(flags: Array<string>): Observable<boolean> {
    return this.featureFlags
      .asObservable()
      .pipe(
        map(
          (featureFlags: Set<string>) =>
            [...new Set(flags)].find((flag) => !featureFlags.has(flag)) ===
            undefined
        )
      );
  }
}
